(function(){
  function root(){ return document.getElementById('hdt-page-cart'); }
  function sid(){ var r=root(); return r ? r.getAttribute('section-id') : null; }

  function initPin(){
    var r=root(); if(!r) return;
    r.querySelectorAll('[data-wl-pin]').forEach(function(box){
      if(box._wlPinInit) return; box._wlPinInit = true;
      var input=box.querySelector('[data-pin]'), entry=box.querySelector('[data-entry]'),
          done=box.querySelector('[data-done]'), err=box.querySelector('[data-err]'),
          etaEl=box.querySelector('[data-eta]'), pinEl=box.querySelector('[data-pincode]');
      var min=parseInt(box.getAttribute('data-min'),10)||3, max=parseInt(box.getAttribute('data-max'),10)||6;
      var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], mons=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      function fmt(d){ return days[d.getDay()]+', '+d.getDate()+' '+mons[d.getMonth()]; }
      function check(){
        var v=(input.value||'').replace(/\D/g,'');
        if(v.length!==6){ err.classList.add('show'); return; }
        err.classList.remove('show');
        var a=new Date(); a.setDate(a.getDate()+min); var b=new Date(); b.setDate(b.getDate()+max);
        pinEl.textContent=v; etaEl.textContent=fmt(a)+' \u2013 '+fmt(b);
        var byStr=b.getDate()+' '+mons[b.getMonth()]+' '+b.getFullYear();
        r.querySelectorAll('[data-wl-eta-item]').forEach(function(el){ el.textContent=byStr; });
        r.querySelectorAll('[data-wl-eta-wrap]').forEach(function(el){ el.hidden=false; });
        entry.style.display='none'; done.classList.add('show');
      }
      box.querySelector('[data-check]').addEventListener('click', check);
      input.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); check(); } });
      input.addEventListener('input', function(){ input.value=input.value.replace(/\D/g,'').slice(0,6); err.classList.remove('show'); });
      box.querySelector('[data-change]').addEventListener('click', function(){ done.classList.remove('show'); entry.style.display='flex'; input.value=''; input.focus(); r.querySelectorAll('[data-wl-eta-wrap]').forEach(function(el){ el.hidden=true; }); });
    });
  }

  function busy(on){ var r=root(); if(r){ r.style.opacity = on ? '.55' : ''; r.style.pointerEvents = on ? 'none' : ''; } }

  function cartNotice(msg){
    try{
      var n=document.getElementById('wl-cart-notice');
      if(!n){ n=document.createElement('div'); n.id='wl-cart-notice'; n.className='wl-cart-notice'; document.body.appendChild(n); }
      n.textContent = msg || 'Couldn\u2019t update your bag \u2014 please try again.';
      n.classList.add('is-show');
      clearTimeout(n._t); n._t=setTimeout(function(){ n.classList.remove('is-show'); }, 3200);
    }catch(e){}
  }

  function animateOut(el, cb){
    if(!el || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)){ cb(); return; }
    el.style.height = el.offsetHeight + 'px';
    el.getBoundingClientRect();
    el.classList.add('is-removing');
    requestAnimationFrame(function(){ el.style.height='0px'; el.style.opacity='0'; });
    setTimeout(cb, 330);
  }

  function initEta(){
    var r=root(); if(!r) return;
    var deliver=r.querySelector('.wl-deliver'); if(!deliver) return;
    /* Logged-in: the pincode is taken automatically from the saved delivery address,
       so show its delivery-date range + reveal the per-item ETA (no manual pincode entry). */
    var min=parseInt(r.getAttribute('data-eta-min'),10)||3;
    var max=parseInt(r.getAttribute('data-eta-max'),10)||6;
    var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], mons=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var a=new Date(); a.setDate(a.getDate()+min); var b=new Date(); b.setDate(b.getDate()+max);
    function fmt(d){ return days[d.getDay()]+', '+d.getDate()+' '+mons[d.getMonth()]; }
    r.querySelectorAll('[data-wl-topeta]').forEach(function(el){ el.textContent=fmt(a)+' \u2013 '+fmt(b); });
    var by=b.getDate()+' '+mons[b.getMonth()]+' '+b.getFullYear();
    r.querySelectorAll('[data-wl-eta-item]').forEach(function(el){ el.textContent=by; });
    r.querySelectorAll('[data-wl-eta-wrap]').forEach(function(el){ el.hidden=false; });
  }

  function initWishBadge(){
    var r=root(); if(!r) return;
    var el=r.querySelector('[data-wl-wishcount]'); if(!el) return;
    var arr=[]; try{ var v=localStorage.getItem('theme4:wishlist:id'); arr=v?v.split(',').filter(Boolean):[]; }catch(e){}
    var n=arr.length; el.textContent=n;
    if(n>0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
  }

  /* The sticky bar used to sit on screen from first paint, duplicating a CTA the shopper
     had not reached yet. It now stays hidden until the checkout card has been scrolled
     to once, then remains for the rest of the session. */
  function initStickyReveal(){
    var r=root(); if(!r) return;
    var bar=r.querySelector('[data-wl-stickybar]'); if(!bar) return;
    var anchor=r.querySelector('.wl-checkout') || r.querySelector('[data-wl-price]');
    if(!anchor || !('IntersectionObserver' in window)){ bar.classList.add('is-on'); return; }
    if(bar._wlRevealInit) return; bar._wlRevealInit=true;
    var io=new IntersectionObserver(function(entries){
      if(entries.some(function(e){ return e.isIntersecting; })){
        bar.classList.add('is-on');
        io.disconnect();
      }
    }, { threshold:0 });
    io.observe(anchor);
  }

  function initOffers(){
    var r=root(); if(!r) return;
    r.querySelectorAll('[data-wl-offers]').forEach(function(view){
      if(view._wlOffersInit) return; view._wlOffersInit=true;
      var track=view.querySelector('.wl-offers__track');
      var slides=track ? track.children.length : 0;
      var card=view.closest('.wl-offers'); var scope=card||view.parentNode;
      var dotsWrap=scope.querySelector('[data-wl-offers-dots]');
      var prevBtn=scope.querySelector('[data-wl-offers-prev]'), nextBtn=scope.querySelector('[data-wl-offers-next]');
      if(slides<2){ if(dotsWrap) dotsWrap.style.display='none'; if(prevBtn) prevBtn.style.display='none'; if(nextBtn) nextBtn.style.display='none'; return; }
      var i=0, timer=null;
      if(dotsWrap){
        dotsWrap.innerHTML='';
        for(var d=0; d<slides; d++){
          var b=document.createElement('button'); b.type='button'; b.className='wl-offers__dot'+(d===0?' is-active':''); b.setAttribute('data-idx', d);
          dotsWrap.appendChild(b);
        }
      }
      /* Native horizontal scrolling with snap points, so the track answers to a swipe or
         trackpad instead of only to the arrows. The transform-based slider it replaced
         could not be dragged at all. */
      function markDots(){ if(dotsWrap){ [].forEach.call(dotsWrap.children, function(dot,idx){ dot.classList.toggle('is-active', idx===i); }); } }
      function go(n, smooth){
        i=(n+slides)%slides;
        var behavior = (smooth===false || window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';
        view.scrollTo({ left: i * view.clientWidth, behavior: behavior });
        markDots();
      }
      var syncing=null;
      view.addEventListener('scroll', function(){
        if(syncing) clearTimeout(syncing);
        syncing=setTimeout(function(){
          var n=Math.round(view.scrollLeft / Math.max(1, view.clientWidth));
          if(n!==i){ i=Math.min(slides-1, Math.max(0, n)); markDots(); }
        }, 90);
      }, { passive:true });
      /* a manual swipe should not be yanked away by the timer mid-gesture */
      view.addEventListener('touchstart', stop, { passive:true });
      view.addEventListener('touchend', start, { passive:true });
      function next(){ go(i+1); }
      function start(){ stop(); timer=setInterval(next, 4200); }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }
      if(dotsWrap){ dotsWrap.addEventListener('click', function(e){ var t=e.target.closest('[data-idx]'); if(t){ go(parseInt(t.getAttribute('data-idx'),10)); start(); } }); }
      if(prevBtn){ prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(i-1); start(); }); }
      if(nextBtn){ nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(i+1); start(); }); }
      if(card){ card.addEventListener('mouseenter', stop); card.addEventListener('mouseleave', start); }
      window.addEventListener('resize', function(){ go(i, false); });
      go(0, false); start();
    });
  }

  /* Rotating product-image "peek" on the right of each Keep Shopping slide.
     Wishlist slide pulls the shopper's actual saved images; recs slide uses
     server-rendered collection images. Empty wishlist gets a unique tile. */
  function normPeekImg(u){ if(!u) return u; if(u.slice(0,2)==='//') u='https:'+u; if(/[?&]width=/.test(u)) return u; return u+(u.indexOf('?')>-1?'&':'?')+'width=300'; }
  function startPeek(pk, urls, delay, badge){
    urls=urls.map(normPeekImg).filter(Boolean);
    if(!urls.length){ return emptyPeek(pk); }
    pk.classList.remove('is-empty'); pk.classList.add('is-img');
    pk.innerHTML='<span class="wl-peek__media"><img class="wl-peek__img is-on" alt=""><img class="wl-peek__img" alt=""><span class="wl-peek__fade"></span></span>'+
      (badge?'<span class="wl-peek__count">'+badge+'</span>':'');
    var layers=pk.querySelectorAll('.wl-peek__img'); var a=layers[0], b=layers[1];
    a.src=urls[0];
    urls.forEach(function(u){ var im=new Image(); im.src=u; });
    if(urls.length<2) return;
    var idx=0, useB=true;
    function tick(){
      idx=(idx+1)%urls.length;
      var show=useB?b:a, hide=useB?a:b;
      show.onload=function(){ show.classList.add('is-on'); hide.classList.remove('is-on'); useB=!useB; };
      show.src=urls[idx];
    }
    if(pk._peekIv) clearInterval(pk._peekIv);
    setTimeout(function(){ tick(); pk._peekIv=setInterval(tick, 3200); }, delay||0);
  }
  function emptyPeek(pk){
    if(pk._peekIv){ clearInterval(pk._peekIv); pk._peekIv=null; }
    pk.classList.remove('is-img'); pk.classList.add('is-empty');
    pk.innerHTML='<span class="wl-peek__seed"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"></path></svg><span class="wl-peek__plus">+</span></span>';
    var slide=pk.closest('.wl-offer');
    if(slide){
      var t=slide.querySelector('.wl-offer__t'), d=slide.querySelector('.wl-offer__d');
      if(t) t.textContent='Start Your Wishlist';
      if(d) d.textContent='Tap the \u2661 on pieces you love';
    }
  }
  function initOfferPeeks(){
    var r=root(); if(!r) return;
    r.querySelectorAll('[data-wl-peek]').forEach(function(pk){
      if(pk._peekInit) return; pk._peekInit=true;
      var delay = pk.hasAttribute('data-wl-peek-wish') ? 0 : 1600;
      var raw=pk.getAttribute('data-imgs');
      if(raw && raw.trim()){
        var cnt=parseInt(pk.getAttribute('data-count'),10);
        startPeek(pk, raw.split('|').filter(Boolean), delay, cnt>0?(cnt+' picks'):'');
        return;
      }
      if(pk.hasAttribute('data-wl-peek-wish')){
        var ids=wishIds();
        if(!ids.length){ emptyPeek(pk); return; }
        var savedBadge=ids.length+' saved';
        wlEnsureMap(ids).then(function(map){
          var handles=ids.map(function(id){ return map[id]; }).filter(Boolean).slice(0,6);
          if(!handles.length){ emptyPeek(pk); return; }
          Promise.all(handles.map(function(h){ return wlGetProduct(h).catch(function(){ return null; }); })).then(function(prods){
            var urls=prods.filter(Boolean).map(function(p){ return p.featured_image||(p.images&&p.images[0]); }).filter(Boolean);
            if(!urls.length){ emptyPeek(pk); } else { startPeek(pk, urls, delay, savedBadge); }
          });
        });
      }
    });
  }

  /* "You May Also Like" drawer (opened from the Keep Shopping carousel). */
  function recsDrawerEl(){ return document.querySelector('[data-wl-recsdrawer]'); }
  function openRecs(){ var d=recsDrawerEl(); if(!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeRecs(){ var d=recsDrawerEl(); if(!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  function swapFrom(data){
    var s2=sid();
    if(data && data.sections && s2 && data.sections[s2]){
      var tmp=document.createElement('div'); tmp.innerHTML=data.sections[s2];
      var fresh=tmp.querySelector('#hdt-page-cart'); var cur=root();
      if(fresh && cur){ fresh.classList.remove('wl-anim-in'); var _dup=fresh.querySelector('[data-wl-wishdrawer]'); if(_dup) _dup.remove(); var _dupR=fresh.querySelector('[data-wl-recsdrawer]'); if(_dupR) _dupR.remove(); cur.replaceWith(fresh); syncCount(data.item_count); initPin(); initEta(); initOffers(); initOfferPeeks(); initWishBadge(); initStickyReveal(); updateSelUI(); refreshSizeAvailability(); return true; }
    }
    return false;
  }
  function showEmptyImmediately(){
    var r=root(); if(!r || r.querySelector('.wl-cart-item:not([data-removing])')) return false;
    var tpl=r.querySelector('[data-wl-empty-template]');
    var host=r.querySelector('.wl-cartx');
    if(!tpl || !tpl.content || !host) return false;
    host.replaceChildren(tpl.content.cloneNode(true));
    syncCount(0);
    return true;
  }

  function postCart(url, body){
    var s=sid(); if(s){ body.sections=[s]; body.sections_url='/cart'; }
    busy(true);    return fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify(body) })
      .then(function(r){
        if(!r.ok){ throw new Error('cart-'+r.status); }
        /* Shopify cart AJAX returns content-type text/javascript, so parse the text
           directly rather than trusting the header; a non-JSON body (e.g. a challenge
           page served with 200) will throw and surface the retry notice. */
        return r.text().then(function(t){ return JSON.parse(t); });
      })
      .then(function(data){ if(!swapFrom(data)){ throw new Error('no-section'); } busy(false); })
      .catch(function(){ busy(false); cartNotice(); });
  }

  /* Poll until the server confirms a code, then do ONE authoritative section render so
     the applied-codes list and its Remove buttons (Liquid-only markup) actually appear.
     Hooked to BOTH apply controls: the modal footer's [data-wl-coupon-apply] and the
     inline [data-cart-discount-apply] "Check" button, because either can apply a code
     and hooking only the former left the modal showing an empty field after success. */
  function watchCouponApplied(){
    var tries=0;
    (function poll(){
      if(++tries>14) return;
      setTimeout(function(){
        fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
          .then(function(x){ return x.json(); })
          .then(function(c){
            if((c.discount_codes||[]).some(function(d){ return d.applicable; })) rerenderSection();
            else poll();
          })
          .catch(function(){});
      }, 500);
    })();
  }

  function changeLine(line, quantity){ return postCart('/cart/change.js', { line:line, quantity:quantity }); }

  /* Authoritative re-render WITHOUT mutating the cart: fetch this section's own HTML
     and swap it in. Used after a coupon apply, where the applied-codes list and its
     Remove buttons only exist in Liquid output. Re-opens the coupon modal afterwards
     because swapFrom() replaces the node and the `is-open` class goes with it. */
  function rerenderSection(){
    var s=sid(); if(!s) return Promise.resolve(false);
    var r0=root();
    var wasOpen=!!(r0 && r0.querySelector('[data-wl-coupon-modal].is-open'));
    return fetch('/cart?section_id='+encodeURIComponent(s), { headers:{ 'Accept':'text/html' } })
      .then(function(x){ return x.text(); })
      .then(function(html){
        return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
          .then(function(x){ return x.json(); })
          .then(function(cart){
            var payload={ sections:{}, item_count:cart.item_count };
            payload.sections[s]=html;
            var ok=swapFrom(payload);
            if(ok && wasOpen){
              var m=root() && root().querySelector('[data-wl-coupon-modal]');
              if(m){ m.classList.add('is-open'); document.body.style.overflow='hidden'; }
            }
            return ok;
          });
      })
      .catch(function(){ return false; });
  }
  /* One bill row per cart-level discount, rebuilt from the server's own list so a code
     stacking with an automatic offer stays itemised ("Discount (WELCOME10)" +
     "Discount (10% OFF)") instead of collapsing into one figure nobody can account for.
       discs  = [{title, amount}] from /cart.js  -> authoritative, rebuild exactly
       null   = optimistic pass (no per-row detail yet) -> scale the rows already on
                screen so their SUM matches, then let the server response correct them. */
  function syncDiscRows(box, discs, cartDisc){
    var anchor=box.querySelector('[data-wl-pd-discs]');
    var rows=[].slice.call(box.querySelectorAll('[data-wl-pd-couponrow]'));
    if(!discs){
      if(!rows.length) return;
      var cur=0; rows.forEach(function(x){ var a=x.querySelector('[data-wl-pd-coupon]'); cur+=a?(parseInt(a.getAttribute('data-cents'),10)||0):0; });
      rows.forEach(function(x,i){
        var a=x.querySelector('[data-wl-pd-coupon]'); if(!a) return;
        var was=parseInt(a.getAttribute('data-cents'),10)||0;
        var now=(cur>0)?Math.round(cartDisc*was/cur):(i===0?cartDisc:0);
        x.style.display = cartDisc>0 ? '' : 'none';
        a.innerHTML='\u2212 '+money(now);
      });
      return;
    }
    if(!anchor) return;
    for(var i=discs.length;i<rows.length;i++){ if(rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]); }
    for(var j=0;j<discs.length;j++){
      var row=rows[j];
      if(!row){
        row=document.createElement('div');
        row.className='wl-sum__row wl-sum__row--save';
        row.setAttribute('data-wl-pd-couponrow','');
        var lab=document.createElement('span'), amt=document.createElement('span');
        amt.setAttribute('data-wl-pd-coupon','');
        row.appendChild(lab); row.appendChild(amt);
        anchor.parentNode.insertBefore(row, anchor);
      }
      row.style.display='';
      row.classList.add('wl-sum__row--save');
      var l=row.querySelector('span'), a2=row.querySelector('[data-wl-pd-coupon]');
      if(l && l!==a2) l.textContent='Discount ('+discs[j].title+')';
      if(a2){ a2.setAttribute('data-cents', String(discs[j].amount)); a2.innerHTML='\u2212 '+money(discs[j].amount); }
    }
  }
  try{ window.wlCartPageAPI = window.wlCartPageAPI || {}; window.wlCartPageAPI.syncDiscRows = syncDiscRows; }catch(e){}
  function writeSummary(v){
    var r=root(); if(!r) return; var box=r.querySelector('[data-wl-price]'); if(!box) return;
    box.setAttribute('data-srv-mrp',v.mrp); box.setAttribute('data-srv-total',v.total); box.setAttribute('data-srv-saved',v.saved); box.setAttribute('data-gift-total',v.gift); box.setAttribute('data-srv-sell',v.sell); box.setAttribute('data-srv-cartdisc',v.cartDisc);
    var e;
    e=box.querySelector('[data-wl-pd-label]'); if(e) e.textContent=v.count+' '+(v.count===1?'item':'items');
    e=box.querySelector('[data-wl-pd-mrp]'); if(e) e.textContent=money(v.mrp);
    var discRow=box.querySelector('[data-wl-pd-discrow]'); e=box.querySelector('[data-wl-pd-disc]'); if(e) e.innerHTML='\u2212 '+money(v.prodDisc); if(discRow) discRow.style.display=v.prodDisc>0?'':'none';
    syncDiscRows(box, v.discs, v.cartDisc);
    e=box.querySelector('[data-wl-pd-total]'); if(e) e.textContent=money(v.total);
    e=r.querySelector('[data-wl-sticky-total]'); if(e) e.textContent=money(v.total);
    var savedRow=box.querySelector('[data-wl-pd-savedrow]'); e=box.querySelector('[data-wl-pd-saved]'); if(e) e.textContent=money(v.saved); if(savedRow) savedRow.style.display=v.saved>0?'':'none';
  }
  function recalcFromCart(cart){
    var r=root(); if(!r||!cart||!cart.items) return;
    var box=r.querySelector('[data-wl-price]'); if(!box) return;
    var giftVid=r.getAttribute('data-gift-vid')||'0';
    var mrpMap={}; [].forEach.call(r.querySelectorAll('.wl-cart-item[data-vid]'), function(row){ mrpMap[row.getAttribute('data-vid')]=parseInt(row.getAttribute('data-unit-mrp'),10)||0; });
    var wl_mrp=0, wl_sell=0, gift_total=0, giftCount=0;
    cart.items.forEach(function(it, idx){
      if(giftVid!=='0' && String(it.variant_id)===String(giftVid)){ gift_total+=it.final_line_price; giftCount+=it.quantity; return; }
      var cmp=mrpMap[String(it.variant_id)]; if(cmp==null||isNaN(cmp)) cmp=it.original_price;
      wl_mrp += cmp*it.quantity; wl_sell += it.original_line_price;
      /* Self-heal: keep each line's shown price + optimistic baseline in sync with the
         server's live price, so if a price changed mid-session the LINE and the TOTAL
         correct together (never a stale line price beside a fresh total). */
      var inp=r.querySelector('.wl-qty__val[data-line="'+(idx+1)+'"]'); var row2=inp?inp.closest('.wl-cart-item'):null;
      if(row2){ row2.setAttribute('data-unit-sell', it.original_price); var nowEl=row2.querySelector('.wl-cart-item__now'); if(nowEl){ var m=money(it.final_price); if(nowEl.textContent!==m) nowEl.textContent=m; } }
    });
    var wl_total=cart.total_price, wl_cart_disc=cart.original_total_price-cart.total_price;
    var discs=(cart.cart_level_discount_applications||[]).map(function(d){ return { title:d.title, amount:d.total_allocated_amount }; });
    writeSummary({ mrp:wl_mrp, sell:wl_sell, prodDisc:wl_mrp-wl_sell, cartDisc:wl_cart_disc, total:wl_total, saved:wl_mrp-(wl_total-gift_total), count:cart.item_count-giftCount, gift:gift_total, discs:discs });
  }
  /* Instant summary straight from the DOM so the total moves in lock-step with the qty
     (no wait for the server); any cart-level coupon is scaled proportionally and then
     reconciled exactly by the server response. */
  function recalcOptimistic(){
    var r=root(); if(!r) return; var box=r.querySelector('[data-wl-price]'); if(!box) return;
    var gift=parseInt(box.getAttribute('data-gift-total'),10)||0;
    var srvSell=parseInt(box.getAttribute('data-srv-sell'),10); var srvDisc=parseInt(box.getAttribute('data-srv-cartdisc'),10)||0;
    var rate=(srvSell>0)?(srvDisc/srvSell):0; if(rate<0) rate=0; if(rate>1) rate=1;
    var wl_mrp=0, wl_sell=0, count=0;
    [].forEach.call(r.querySelectorAll('.wl-cart-item[data-vid]:not([data-removing])'), function(row){
      var inp=row.querySelector('.wl-qty__val'); var q=inp?(parseInt(inp.value,10)||0):0;
      wl_mrp += (parseInt(row.getAttribute('data-unit-mrp'),10)||0)*q;
      wl_sell += (parseInt(row.getAttribute('data-unit-sell'),10)||0)*q;
      count += q;
    });
    var wl_cart_disc=Math.round(wl_sell*rate); var wl_total=wl_sell-wl_cart_disc+gift;
    writeSummary({ mrp:wl_mrp, sell:wl_sell, prodDisc:wl_mrp-wl_sell, cartDisc:wl_cart_disc, total:wl_total, saved:wl_mrp-(wl_total-gift), count:count, gift:gift });
  }
  function reconcileFromServer(){
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(cart){
      recalcFromCart(cart); syncCount(cart.item_count);
      var r2=root(); if(!r2) return;
      (cart.items||[]).forEach(function(it,i){ var inp=r2.querySelector('.wl-qty__val[data-line="'+(i+1)+'"]'); if(!inp) return; inp.value=it.quantity; var wrap=inp.closest('[data-wl-qty]'); if(!wrap) return; var mn=parseInt(inp.getAttribute('data-min'),10)||1, mx=parseInt(inp.getAttribute('data-max'),10)||9999; var d=wrap.querySelector('[data-wl-dec]'), u=wrap.querySelector('[data-wl-inc]'); if(d) d.disabled=it.quantity<=mn; if(u) u.disabled=it.quantity>=mx; });
      refreshSizeAvailability();
    }).catch(function(){});
  }
  var _qtySeq=0;
  function changeQty(line, quantity){
    var mySeq=++_qtySeq;
    return fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ line:line, quantity:quantity }) })
      .then(function(rr){ if(!rr.ok) throw new Error('cart-'+rr.status); return rr.text().then(function(t){ return JSON.parse(t); }); })
      .then(function(cart){ syncCount(cart.item_count); if(mySeq===_qtySeq){ recalcFromCart(cart); refreshSizeAvailability(); } })
      .catch(function(){ if(mySeq===_qtySeq){ cartNotice(); reconcileFromServer(); } });
  }
  function removeVariant(vid){ return postCart('/cart/change.js', { id:vid, quantity:0 }); }
  function addVariant(vid){ return postCart('/cart/add.js', { items:[{ id:vid, quantity:1 }] }); }
  function addGift(vid, props){ var it={ id:vid, quantity:1 }; if(props && Object.keys(props).length){ it.properties=props; } return postCart('/cart/add.js', { items:[it] }); }
  function updateCart(updates){ return postCart('/cart/update.js', { updates:updates }); }

  /* ── Live per-size availability in the cart's size dropdowns ──────────────
     A size option is greyed when it can't be switched to: either the variant is
     unavailable (server data-avail=0) or all of its remaining stock is already
     committed elsewhere in the bag (data-max minus qty already in cart <= 0). */
  function cartVidQty(){
    var r=root(); var m={}; if(!r) return m;
    [].forEach.call(r.querySelectorAll('.wl-cart-item[data-vid]:not([data-removing])'), function(row){
      var vid=row.getAttribute('data-vid'); if(!vid) return;
      var inp=row.querySelector('.wl-qty__val'); var q=inp?(parseInt(inp.value,10)||0):0;
      m[vid]=(m[vid]||0)+q;
    });
    return m;
  }
  function refreshSizeAvailability(){
    var r=root(); if(!r) return; var m=cartVidQty();
    [].forEach.call(r.querySelectorAll('.wl-size__opt'), function(opt){
      if(opt.classList.contains('is-sel')){ opt.disabled=false; return; }
      opt.classList.remove('is-inbag');
      if(opt.getAttribute('data-avail')==='0'){ opt.classList.add('is-out'); opt.disabled=true; opt.removeAttribute('title'); return; }
      var vid=opt.getAttribute('data-vid'); var max=parseInt(opt.getAttribute('data-max'),10); if(isNaN(max)) max=999;
      var allowed=max-(m[vid]||0);
      if(allowed<=0){ opt.classList.add('is-inbag'); opt.classList.remove('is-out'); opt.disabled=true; opt.setAttribute('title','Already in your bag'); }
      else { opt.classList.remove('is-out'); opt.disabled=false; opt.removeAttribute('title'); }
    });
  }
  function changeVariant(line, newVid, qty, vmax, optEl){
    var r=root(); if(!r) return;
    if(typeof vmax!=='number' || isNaN(vmax) || vmax<0) vmax=999;
    var nv=parseInt(newVid,10);
    /* Stock guard from the DOM (instant): the target size may already sit on another
       line, so switching this line would over-commit inventory. Cap or block. */
    var existing=0;
    [].forEach.call(r.querySelectorAll('.wl-cart-item[data-vid]'), function(row){
      var inp=row.querySelector('.wl-qty__val'); var li=inp?parseInt(inp.getAttribute('data-line'),10):0;
      if(li!==line && String(row.getAttribute('data-vid'))===String(nv)){ existing += inp?(parseInt(inp.value,10)||0):0; }
    });
    var allowed=vmax-existing;
    if(allowed<=0){ cartNotice(existing>0 ? 'That size is already in your bag' : 'That size is out of stock'); return; }
    var newQty=qty; if(newQty>allowed){ newQty=allowed; cartNotice('Only '+allowed+' left in that size'); }
    /* Optimistic: swap this row's variant + prices + the summary instantly (no dim, no
       section render), then rebuild the cart on the server and reconcile exactly. */
    var rowEl=null, rows=r.querySelectorAll('.wl-cart-item');
    for(var i=0;i<rows.length;i++){ var qq=rows[i].querySelector('.wl-qty__val'); if(qq && parseInt(qq.getAttribute('data-line'),10)===line){ rowEl=rows[i]; break; } }
    if(rowEl && optEl){
      var price=parseInt(optEl.getAttribute('data-price'),10);
      var mrp=parseInt(optEl.getAttribute('data-mrp'),10);
      var label=optEl.textContent.trim();
      rowEl.setAttribute('data-vid', nv);
      if(!isNaN(price)) rowEl.setAttribute('data-unit-sell', price);
      if(!isNaN(mrp)) rowEl.setAttribute('data-unit-mrp', mrp);
      var qi=rowEl.querySelector('.wl-qty__val');
      if(qi){ qi.value=newQty; qi.setAttribute('data-max', vmax); var mn=parseInt(qi.getAttribute('data-min'),10)||1; var wrap=qi.closest('[data-wl-qty]'); if(wrap){ var d=wrap.querySelector('[data-wl-dec]'), u=wrap.querySelector('[data-wl-inc]'); if(d) d.disabled=newQty<=mn; if(u) u.disabled=newQty>=vmax; } }
      var dd=rowEl.querySelector('.wl-size'); if(dd){ dd.setAttribute('data-qty', newQty); var tog=dd.querySelector('[data-wl-size-toggle] span'); if(tog) tog.textContent=label; [].forEach.call(dd.querySelectorAll('.wl-size__opt'), function(o){ o.classList.toggle('is-sel', String(o.getAttribute('data-vid'))===String(nv)); }); }
      if(!isNaN(price)){
        var nowEl=rowEl.querySelector('.wl-cart-item__now'); if(nowEl) nowEl.textContent=money(price);
        var mrpEl=rowEl.querySelector('.wl-cart-item__mrp'), offEl=rowEl.querySelector('.wl-cart-item__off');
        if(!isNaN(mrp) && mrp>price){ var pct=Math.round((mrp-price)/mrp*100); if(mrpEl){ mrpEl.textContent=money(mrp); mrpEl.style.display=''; } if(offEl){ offEl.textContent=pct+'% OFF'; offEl.style.display=''; } }
        else { if(mrpEl) mrpEl.style.display='none'; if(offEl) offEl.style.display='none'; }
      }
    }
    recalcOptimistic(); refreshSizeAvailability();
    /* Background rebuild (preserves order + gift + properties), NO section render. */
    var mySeq=++_qtySeq;
    fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(rr){ return rr.json(); })
      .then(function(cart){
        var items=cart.items.map(function(it, idx){
          var vid=(idx===(line-1))?nv:it.variant_id;
          var o={ id:vid, quantity:(idx===(line-1))?newQty:it.quantity };
          if(it.properties && Object.keys(it.properties).length){ o.properties=it.properties; }
          if(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan){ o.selling_plan=it.selling_plan_allocation.selling_plan.id; }
          return o;
        });
        items.reverse();
        return fetch('/cart/clear.js', { method:'POST', headers:{ 'Accept':'application/json' } })
          .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ items:items }) }); })
          .then(function(){ return fetch('/cart.js', { headers:{ 'Accept':'application/json' } }); });
      })
      .then(function(rr){ return rr.json(); })
      .then(function(cart){ if(mySeq!==_qtySeq) return; recalcFromCart(cart); syncCount(cart.item_count); refreshSizeAvailability(); var r2=root(); if(r2){ (cart.items||[]).forEach(function(it,i){ var inp=r2.querySelector('.wl-qty__val[data-line="'+(i+1)+'"]'); if(inp) inp.value=it.quantity; }); } })
      .catch(function(){ cartNotice(); reconcileFromServer(); });
  }

  function selItems(){ var r=root(); return r ? Array.prototype.slice.call(r.querySelectorAll('[data-wl-itemsel]')) : []; }
  function updateSelUI(){
    var r=root(); if(!r) return;
    var items=selItems(); var n=0;
    items.forEach(function(c){ if(c.checked) n++; });
    var tot=items.length;
    var seln=r.querySelector('[data-wl-seln]'); if(seln) seln.textContent=n;
    var seltot=r.querySelector('[data-wl-seltot]'); if(seltot) seltot.textContent=tot;
    var all=r.querySelector('[data-wl-selall]'); if(all){ all.checked = tot>0 && n===tot; all.indeterminate = n>0 && n<tot; }
    var rm=r.querySelector('[data-wl-bulk-remove]'), wl=r.querySelector('[data-wl-bulk-wish]');
    if(rm) rm.disabled = n===0; if(wl) wl.disabled = n===0;
    recalcPrice();
  }

  /* EXACT money. This previously did Math.round(cents/100), which dropped paise:
     a 10% coupon showed the total as ₹4,586 when ₹4,586.40 is charged, and the
     discount as ₹510 instead of ₹509.60 — disagreeing with checkout and with the
     cart drawer. Paise are shown only when they exist. */
  function money(cents){
    var v = Math.round(cents||0);
    var neg = v < 0; v = Math.abs(v);
    var rupees = Math.floor(v/100), paise = v % 100;
    var s = rupees.toLocaleString('en-IN');
    if(paise) s += '.' + (paise < 10 ? '0'+paise : paise);
    return (neg ? '-' : '') + '\u20B9' + s;
  }

  function recalcPrice(){
    var r=root(); if(!r) return;
    var box=r.querySelector('[data-wl-price]'); if(!box) return;
    if(!r.querySelector('[data-wl-itemsel]')){ return; }
    var items=selItems(); var total=items.length, checked=0, selMrp=0, selPay=0;
    items.forEach(function(c){ if(c.checked){ checked++; selMrp += parseInt(c.getAttribute('data-mrp'),10)||0; selPay += parseInt(c.getAttribute('data-pay'),10)||0; } });
    var giftTotal = parseInt(box.getAttribute('data-gift-total'),10)||0;
    var allSel = total>0 && checked===total;
    var mrp, totalAmt, disc, saved;
    if(allSel){
      mrp = parseInt(box.getAttribute('data-srv-mrp'),10)||selMrp;
      totalAmt = parseInt(box.getAttribute('data-srv-total'),10);
      saved = parseInt(box.getAttribute('data-srv-saved'),10);
      disc = mrp - selPay;
    } else {
      mrp = selMrp; totalAmt = selPay + giftTotal; disc = selMrp - selPay; saved = selMrp - selPay;
    }
    var label=box.querySelector('[data-wl-pd-label]'); if(label) label.textContent = checked + ' ' + (checked===1?'item':'items');
    var mrpEl=box.querySelector('[data-wl-pd-mrp]'); if(mrpEl) mrpEl.textContent = money(mrp);
    var discRow=box.querySelector('[data-wl-pd-discrow]'), discEl=box.querySelector('[data-wl-pd-disc]');
    if(discEl) discEl.innerHTML = '\u2212 ' + money(disc);
    if(discRow) discRow.style.display = disc>0 ? '' : 'none';
    var cartDisc=parseInt(box.getAttribute('data-srv-cartdisc'),10)||0;
    /* every discount row, not just the first - a stacked coupon renders several */
    var show=(allSel && cartDisc>0) ? '' : 'none';
    [].forEach.call(box.querySelectorAll('[data-wl-pd-couponrow]'), function(x){ x.style.display=show; });
    var totalEl=box.querySelector('[data-wl-pd-total]'); if(totalEl) totalEl.textContent = money(totalAmt);
    var stTotal=r.querySelector('[data-wl-sticky-total]'); if(stTotal) stTotal.textContent = money(totalAmt);
    var savedRow=box.querySelector('[data-wl-pd-savedrow]'), savedEl=box.querySelector('[data-wl-pd-saved]');
    if(savedEl) savedEl.textContent = money(saved);
    if(savedRow) savedRow.style.display = saved>0 ? '' : 'none';
    r.querySelectorAll('[data-wl-checkout]').forEach(function(co){ co.disabled = checked===0; co.style.opacity = checked===0 ? '.5' : ''; });
  }

  /* SHIPROCKET IS THE REAL CHECKOUT IN INDIA. theme.liquid's timezone script hides
     `.wl-checkout__btn` and shows `.shiprocket-headless`, but the STICKY bar's button was
     never added to that hide-list - so on tablet and mobile, where the sticky bar is the
     only checkout control on screen, "Check out" still navigated to Shopify's native
     /checkout and bypassed Shiprocket completely.
     It now PROXIES to the button Shiprocket has already rendered, rather than dropping a
     second `.shiprocket-headless` into the sticky bar - two instances of the same
     third-party widget would both bind to the same cart.
     Outside India that host is `display:none`, so this returns null and the native
     /checkout runs exactly as before. */
  function srCheckoutBtn(){
    var host = document.querySelector('#hdt-page-cart .wl-checkout .shiprocket-headless');
    if(!host) return null;
    try{ if(getComputedStyle(host).display === 'none') return null; }catch(e){ return null; }
    return host.querySelector('button.sr-headless-checkout');
  }
  function goCheckout(){
    var sr = srCheckoutBtn();
    if(sr){ sr.click(); return; }
    window.location.href = '/checkout';
  }

  /* The sticky bar is now SERVER-RENDERED in its final "BUY NOW" state (see the comment
     in sections/wl-main-cart.liquid). The old stickyAsBuyNow() + waitForShiprocket()
     pair used to poll for Shiprocket's widget (500ms x 30) and then wipe and rebuild the
     button, which MEASURED as a visible relabel 650ms after first paint on every single
     cart visit. Both were deleted; nothing here touches the button's appearance any more.
     goCheckout() above still proxies the CLICK to Shiprocket when it is present, so the
     behaviour is unchanged - only the second paint is gone. */

  function checkoutSelected(){
    var items=selItems(), ups={}, anyUnsel=false, anySel=false;
    if(!items.length){ goCheckout(); return; }
    items.forEach(function(c){ if(c.checked){ anySel=true; } else { anyUnsel=true; addWishlist(c.getAttribute('data-pid')); ups[c.getAttribute('data-vid')]=0; } });
    if(!anySel) return;
    if(!anyUnsel){ goCheckout(); return; }
    fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ updates:ups }) })
      .then(function(){ goCheckout(); })
      .catch(function(){ goCheckout(); });
  }

  function syncCount(n){
    if(typeof n === 'undefined') return;
    document.querySelectorAll('hdt-cart-count, [data-cart-count], .hdt-cart-count, .cart-count-bubble, .hdt-header__action--cart .hdt-count').forEach(function(el){ el.textContent = n; });
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true })); } catch(e){}
  }

  function addWishlist(pid){
    try{
      var key='theme4:wishlist:id';
      var arr=localStorage.getItem(key) ? localStorage.getItem(key).split(',').filter(Boolean) : [];
      if(pid && arr.indexOf(pid)===-1){ arr.push(pid); localStorage.setItem(key, arr.toString()); }
      document.dispatchEvent(new CustomEvent('theme4:wishlist:update', { bubbles:true, detail:arr }));
    }catch(e){}
  }

  /* Each cart row is its own positioned card, so an open size dropdown is trapped
     inside its row's stacking context and the NEXT row paints over the lower
     options (verified: XL / 2XL were unclickable, elementFromPoint returned the
     following .wl-cart-item). Mark the owning row so CSS can lift it. Done in JS
     rather than with :has() alone so it also works on engines without :has(). */
  /* Drop UP instead of DOWN when the menu would collide with the bottom of the
     viewport or the fixed .wl-cart-stickybar. Measured on a landscape phone
     (844x390): the menu is 138px tall but only 102px is free below the toggle
     before the bar (z-60) starts, so the last option (2XL) was painted over and
     unclickable in Chromium, Firefox AND WebKit. 176px was free above, so flipping
     fits. Deliberately NOT solved by raising the row above the bar -- that would
     lift the whole product card over the checkout CTA. */
  function placeSizeMenu(dd){
    if(!dd) return;
    dd.classList.remove('wl-size--up');
    var menu=dd.querySelector('.wl-size__menu'), btn=dd.querySelector('[data-wl-size-toggle]');
    if(!menu || !btn) return;
    var br=btn.getBoundingClientRect(), mh=menu.offsetHeight;
    var bar=document.querySelector('.wl-cart-stickybar');
    var limit=window.innerHeight;
    if(bar && bar.offsetHeight){ var bt=bar.getBoundingClientRect().top; if(bt>0 && bt<limit) limit=bt; }
    var below=limit-br.bottom-6, above=br.top-6;
    if(below<mh && above>=mh) dd.classList.add('wl-size--up');
  }

  function syncSizeRows(r){
    if(!r) return;
    r.querySelectorAll('.wl-cart-item.wl-size-open').forEach(function(row){
      if(!row.querySelector('.wl-size.is-open')) row.classList.remove('wl-size-open');
    });
    r.querySelectorAll('.wl-size.wl-size--up').forEach(function(dd){
      if(!dd.classList.contains('is-open')) dd.classList.remove('wl-size--up');
    });
    r.querySelectorAll('.wl-size.is-open').forEach(function(dd){
      var row=dd.closest('.wl-cart-item'); if(row) row.classList.add('wl-size-open');
      placeSizeMenu(dd);
    });
  }

  document.addEventListener('click', function(e){
    var r=root(); if(!r || !r.contains(e.target)) return;

    // ── slide-in menu (hamburger) ──
    if(e.target.closest('[data-wl-menu-open]')){ var _m=r.querySelector('[data-wl-menu]'); if(_m){ _m.classList.add('is-open'); document.body.style.overflow='hidden'; } return; }
    if(e.target.closest('[data-wl-menu-close]')){ var _m2=r.querySelector('[data-wl-menu]'); if(_m2){ _m2.classList.remove('is-open'); document.body.style.overflow=''; } return; }

    // ── size dropdown (custom) ──
    if(!e.target.closest('.wl-size')){ r.querySelectorAll('.wl-size.is-open').forEach(function(x){ x.classList.remove('is-open'); }); syncSizeRows(r); }
    var stoggle=e.target.closest('[data-wl-size-toggle]');
    if(stoggle){
      e.preventDefault();
      var dd=stoggle.closest('.wl-size'); var wasOpen=dd.classList.contains('is-open');
      r.querySelectorAll('.wl-size.is-open').forEach(function(x){ x.classList.remove('is-open'); });
      if(!wasOpen) dd.classList.add('is-open');
      syncSizeRows(r);
      return;
    }
    var sopt=e.target.closest('.wl-size__opt');
    if(sopt){
      e.preventDefault();
      if(sopt.classList.contains('is-out')||sopt.classList.contains('is-inbag')||sopt.disabled) return;
      var sdd=sopt.closest('.wl-size'); var sline=parseInt(sdd.getAttribute('data-line'),10);
      var sqInput=sopt.closest('.wl-cart-item').querySelector('.wl-qty__val'); var sqty=sqInput?(parseInt(sqInput.value,10)||1):(parseInt(sdd.getAttribute('data-qty'),10)||1);
      var svid=sopt.getAttribute('data-vid'); var smax=parseInt(sopt.getAttribute('data-max'),10); if(isNaN(smax)) smax=999; sdd.classList.remove('is-open'); syncSizeRows(r);
      if(svid && !sopt.classList.contains('is-sel')) changeVariant(sline, svid, sqty, smax, sopt);
      return;
    }

    // ── change-address slide-over ──
    var modal=r.querySelector('[data-wl-addr-modal]');
    var aopen=e.target.closest('[data-wl-addr-open]'), aclose=e.target.closest('[data-wl-addr-close]'),
        adeliver=e.target.closest('[data-wl-addr-deliver]'), mcheck=e.target.closest('[data-wl-modal-check]');
    if(aopen){ e.preventDefault(); if(modal){ modal.classList.add('is-open'); document.body.style.overflow='hidden'; } return; }
    if(aclose){ if(modal){ modal.classList.remove('is-open'); document.body.style.overflow=''; } return; }
    if(adeliver){
      e.preventDefault();
      var bar=r.querySelector('.wl-deliver');
      if(bar){
        var z=bar.querySelector('[data-wl-zip]'), n=bar.querySelector('[data-wl-name]'), a=bar.querySelector('[data-wl-addrline]');
        if(z && adeliver.getAttribute('data-zip')) z.textContent=adeliver.getAttribute('data-zip');
        if(n && adeliver.getAttribute('data-name')) n.textContent=adeliver.getAttribute('data-name');
        if(a && adeliver.getAttribute('data-line')) a.textContent=adeliver.getAttribute('data-line');
      }
      initEta();
      r.querySelectorAll('.wl-addr').forEach(function(l){ l.classList.remove('is-sel'); });
      var lab=adeliver.closest('.wl-addr');
      if(lab){ lab.classList.add('is-sel'); var rad=lab.querySelector('[data-wl-addr-radio]'); if(rad) rad.checked=true; }
      if(modal){ modal.classList.remove('is-open'); document.body.style.overflow=''; }
      return;
    }
    if(mcheck && modal){
      e.preventDefault();
      var pin=modal.querySelector('[data-wl-modal-pin]'); var v=(pin.value||'').replace(/\D/g,'');
      if(v.length===6){ var zz=r.querySelector('.wl-deliver [data-wl-zip]'); if(zz) zz.textContent=v; modal.classList.remove('is-open'); document.body.style.overflow=''; }
      return;
    }

    // ── apply-coupon slide-over ──
    var cmodal=r.querySelector('[data-wl-coupon-modal]');
    var copen=e.target.closest('[data-wl-coupon-open]'), cclose=e.target.closest('[data-wl-coupon-close]'),
        capply=e.target.closest('[data-wl-coupon-apply]');
    if(copen){ e.preventDefault(); if(cmodal){ cmodal.classList.add('is-open'); document.body.style.overflow='hidden'; } return; }
    if(cclose){ if(cmodal){ cmodal.classList.remove('is-open'); document.body.style.overflow=''; } return; }

    if(capply && cmodal){
      e.preventDefault();
      var ab=cmodal.querySelector('[data-cart-discount-apply]'); if(ab) ab.click();
      setTimeout(function(){ reconcileFromServer(); }, 900);
      setTimeout(function(){ reconcileFromServer(); }, 2200);
      watchCouponApplied();
      return;
    }
    /* The raw "Check" button applies too - refresh on that path as well. No
       preventDefault: the theme's own hdt-cart-discount element must still handle it. */
    if(e.target.closest('[data-cart-discount-apply]')) watchCouponApplied();
    /* Remove an applied coupon. Shopify's /cart/update.js `discount` param REPLACES the
       whole code set, so post the codes we are KEEPING (empty string clears them all).
       postCart re-renders the section authoritatively, which is what we want here: a
       code leaving changes the bill structure, not just a figure. */
    var crem=e.target.closest('[data-wl-coupon-remove]');
    if(crem){
      e.preventDefault(); e.stopPropagation();
      var gone=crem.getAttribute('data-code')||'', keep=[];
      r.querySelectorAll('[data-wl-coupon-remove]').forEach(function(b){
        var c=b.getAttribute('data-code'); if(c && c!==gone) keep.push(c);
      });
      crem.disabled=true;
      postCart('/cart/update.js', { discount:keep.join(',') });
      return;
    }
    var crow=e.target.closest('.wl-coupon-row');
    if(crow && cmodal && cmodal.contains(crow)){
      var radio=crow.querySelector('[data-wl-coupon-select]');
      if(radio){
        radio.checked=true;
        var code=radio.getAttribute('data-code'), save=radio.getAttribute('data-save');
        var inp=cmodal.querySelector('[data-cart-discount-input]'); if(inp && code) inp.value=code;
        cmodal.querySelectorAll('.wl-coupon-row').forEach(function(l){ l.classList.remove('is-sel'); });
        crow.classList.add('is-sel');
        var maxEl=cmodal.querySelector('[data-wl-coupon-max]'); if(maxEl) maxEl.textContent = save || '\u2014';
      }
      return;
    }

    var inc=e.target.closest('[data-wl-inc]'), dec=e.target.closest('[data-wl-dec]'),
        rem=e.target.closest('[data-wl-remove]'), mv=e.target.closest('[data-wl-move]');
    var gopen=e.target.closest('[data-wl-gift-open]'), gclose=e.target.closest('[data-wl-gift-close]'),
        gapply=e.target.closest('[data-wl-gift-apply]'), grem=e.target.closest('[data-wl-gift-remove]');
    var gmodal=r.querySelector('[data-wl-gift-modal]');
    if(gopen){ e.preventDefault(); if(gmodal){ gmodal.classList.add('is-open'); document.body.style.overflow='hidden'; } return; }
    if(gclose){ if(gmodal){ gmodal.classList.remove('is-open'); document.body.style.overflow=''; } return; }
    if(gapply){
      e.preventDefault();
      var gvid=gapply.getAttribute('data-vid');
      if(gmodal){ gmodal.classList.remove('is-open'); document.body.style.overflow=''; }
      if(!gvid || gvid==='0') return;
      var props={};
      var rec=gmodal.querySelector('[data-gift-recipient]'), msg=gmodal.querySelector('[data-gift-message]'), snd=gmodal.querySelector('[data-gift-sender]');
      if(rec && rec.value.trim()) props['To']=rec.value.trim();
      if(msg && msg.value.trim()) props['Message']=msg.value.trim();
      if(snd && snd.value.trim()) props['From']=snd.value.trim();
      addGift(gvid, props);
      return;
    }
    if(grem){ e.preventDefault(); removeVariant(grem.getAttribute('data-vid')); return; }

    // ── bulk selection actions ──
    var brem=e.target.closest('[data-wl-bulk-remove]'), bwish=e.target.closest('[data-wl-bulk-wish]');
    if(brem){
      e.preventDefault(); if(brem.disabled) return;
      var ups={}; selItems().forEach(function(c){ if(c.checked){ ups[c.getAttribute('data-vid')]=0; } });
      if(Object.keys(ups).length) updateCart(ups);
      return;
    }
    if(bwish){
      e.preventDefault(); if(bwish.disabled) return;
      var ups2={}; selItems().forEach(function(c){ if(c.checked){ addWishlist(c.getAttribute('data-pid')); ups2[c.getAttribute('data-vid')]=0; } });
      if(Object.keys(ups2).length) updateCart(ups2);
      return;
    }

    var cocheck=e.target.closest('[data-wl-checkout]');
    if(cocheck){ e.preventDefault(); if(!cocheck.disabled) checkoutSelected(); return; }

    if(!(inc||dec||rem||mv)) return;
    e.preventDefault();
    if(inc || dec){
      var wrap=(inc||dec).closest('[data-wl-qty]'); var input=wrap.querySelector('input');
      var line=parseInt(input.getAttribute('data-line'),10);
      var min=parseInt(input.getAttribute('data-min'),10)||1;
      var max=parseInt(input.getAttribute('data-max'),10)||9999;
      var cur=parseInt(input.value,10)||1;
      var next=inc ? cur+1 : cur-1;
      if(next < min || next > max) return;
      input.value=next;
      var _decB=wrap.querySelector('[data-wl-dec]'), _incB=wrap.querySelector('[data-wl-inc]');
      if(_decB) _decB.disabled=(next<=min);
      if(_incB) _incB.disabled=(next>=max);
      refreshSizeAvailability();
      recalcOptimistic();
      changeQty(line, next);
    } else if(rem){
      var _rl=parseInt(rem.getAttribute('data-line'),10);
      var _rw=rem.closest('.wl-cart-item'); if(_rw) _rw.setAttribute('data-removing','1');
      recalcOptimistic(); refreshSizeAvailability();
      animateOut(_rw, function(){ changeLine(_rl, 0); });
    } else if(mv){
      addWishlist(mv.getAttribute('data-pid'));
      var _ml=parseInt(mv.getAttribute('data-line'),10);
      var _mw=mv.closest('.wl-cart-item'); if(_mw) _mw.setAttribute('data-removing','1');
      recalcOptimistic(); refreshSizeAvailability();
      animateOut(_mw, function(){ changeLine(_ml, 0); });
    }
  });

  document.addEventListener('input', function(e){
    var m = e.target && e.target.closest ? e.target.closest('[data-gift-message]') : null;
    if(!m) return;
    var box = m.closest('[data-wl-gift-modal]'); if(!box) return;
    var c = box.querySelector('[data-gift-count]'); if(c) c.textContent = m.value.length;
  });

  document.addEventListener('change', function(e){
    var r=root(); if(!r || !r.contains(e.target)) return;
    if(e.target.closest('[data-wl-selall]')){
      var chk=e.target.checked;
      selItems().forEach(function(c){ c.checked=chk; });
      updateSelUI(); return;
    }
    if(e.target.closest('[data-wl-itemsel]')){ updateSelUI(); return; }
  });

  // ── wishlist slide-over drawer ──
  var SEARCH_URL = (root() && root().getAttribute('data-search-url')) || '/search';
  function wishDrawerEl(){ return document.querySelector('[data-wl-wishdrawer]'); }
  function wishIds(){ try{ return (localStorage.getItem('theme4:wishlist:id')||'').split(',').filter(Boolean); }catch(e){ return []; } }
  function closeWish(){ var d=wishDrawerEl(); if(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }
  function openWish(){ var d=wishDrawerEl(); if(!d){ window.location.href='/search/?view=wishlist'; return; } d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; renderWish(); }
  var _wishBusy=false;
  function wlEsc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function wlINR(paise){ try{ return '\u20B9'+Math.round((paise||0)/100).toLocaleString('en-IN'); }catch(e){ return '\u20B9'+Math.round((paise||0)/100); } }
  function wlCardHTML(p, pid, inbag){
    var img=p.featured_image||(p.images&&p.images[0])||'';
    if(img && img.slice(0,2)==='//') img='https:'+img;
    if(img) img=img.replace(/\.(jpg|jpeg|png|webp)(\?|$)/i,'_360x.$1$2');
    var now=p.price, cmp=p.compare_at_price||(p.variants&&p.variants[0]&&p.variants[0].compare_at_price)||0;
    var off=(cmp>now)?Math.round((cmp-now)/cmp*100):0;
    var sizeIdx=-1; (p.options||[]).forEach(function(o,i){ var nm=(typeof o==='string'?o:(o&&o.name))||''; if(/size|waist/i.test(nm)) sizeIdx=i; });
    if(sizeIdx<0 && (p.options||[]).length===1) sizeIdx=0;
    var pills='', inbagList=[]; if(sizeIdx>=0){ var seen={}; (p.variants||[]).forEach(function(v){ var val=v['option'+(sizeIdx+1)]; if(val==null||seen[val]) return; seen[val]=1; var bag=inbag&&inbag[String(v.id)]; if(bag) inbagList.push(val); pills+='<button type="button" class="wl-wl-size'+(v.available?'':' is-oos')+(bag?' is-inbag':'')+'" data-vid="'+v.id+'"'+((v.available&&!bag)?'':' disabled')+'>'+wlEsc(val)+'</button>'; }); }
    var single=''; if(!pills){ var av=(p.variants||[]).filter(function(v){ return v.available; })[0]||(p.variants||[])[0]; single=av?av.id:''; }
    var singleInBag = single && inbag && inbag[String(single)];
    var url=p.url||('/products/'+p.handle);
    var priceHTML='<span class="wl-wl-now">'+wlINR(now)+'</span>'+(off?' <span class="wl-wl-mrp">'+wlINR(cmp)+'</span> <span class="wl-wl-off">'+off+'% OFF</span>':'');
    var inbagCap = inbagList.length ? '<div class="wl-wl-inbag"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> In bag: <b>'+inbagList.map(wlEsc).join(', ')+'</b></div>' : '';
    return '<div class="wl-wl-card" data-pid="'+wlEsc(pid)+'">'+
      '<button type="button" class="wl-wl-del" data-wl-wl-remove data-pid="'+wlEsc(pid)+'" aria-label="Remove from wishlist"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg></button>'+
      '<a class="wl-wl-img" href="'+wlEsc(url)+'">'+(img?'<img src="'+wlEsc(img)+'" alt="'+wlEsc(p.title)+'" loading="lazy">':'')+'</a>'+
      '<div class="wl-wl-info">'+
        '<a class="wl-wl-title" href="'+wlEsc(url)+'">'+wlEsc(p.title)+'</a>'+
        '<div class="wl-wl-price">'+priceHTML+'</div>'+
        (pills?'<div class="wl-wl-sizes" role="group" aria-label="Select size">'+pills+'</div>':'')+
        inbagCap+
        '<button type="button" class="wl-wl-atc'+(singleInBag?' is-inbag':'')+'" data-wl-wl-add'+((single&&!singleInBag)?' data-vid="'+single+'"':' disabled')+'>'+(singleInBag?'In Bag \u2713':(single?'Add to Bag':'Select Size'))+'</button>'+
      '</div>'+
    '</div>';
  }
  var _wishMap=null, _wishCache={}, _wishCartVids={}, _cartInflight=null, _wishMapInflight=null;
  function wlLoadCart(){ if(_cartInflight) return _cartInflight; _cartInflight=fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ _wishCartVids={}; (c.items||[]).forEach(function(it){ _wishCartVids[String(it.variant_id)]=it.quantity; }); _cartInflight=null; return _wishCartVids; }).catch(function(){ _cartInflight=null; return _wishCartVids; }); return _cartInflight; }
  function wlUpdateInbag(card){ if(!card) return; var list=[].map.call(card.querySelectorAll('.wl-wl-size.is-inbag'), function(b){ return b.textContent.trim(); }); var cap=card.querySelector('.wl-wl-inbag'); if(!list.length){ if(cap) cap.remove(); return; } var html='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> In bag: <b>'+list.map(wlEsc).join(', ')+'</b>'; if(!cap){ cap=document.createElement('div'); cap.className='wl-wl-inbag'; var sizes=card.querySelector('.wl-wl-sizes'); if(!sizes) return; sizes.insertAdjacentElement('afterend', cap); } cap.innerHTML=html; }
  function wlEmptyHTML(){ return '<div class="wl-wishdrawer__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg><p>Nothing saved yet \u2014 every piece you love, kept in one place.</p><a href="'+(SEARCH_URL||'/search')+'" class="wl-wishdrawer__browse">Browse the collection</a></div>'; }
  function wlSkeletonHTML(id){ return '<div class="wl-wl-card wl-wl-card--skel" data-pid="'+wlEsc(id)+'"><div class="wl-wl-sk wl-wl-sk-img"></div><div class="wl-wl-info"><div class="wl-wl-sk wl-wl-sk-line" style="width:82%"></div><div class="wl-wl-sk wl-wl-sk-line" style="width:42%;margin-top:9px"></div><div class="wl-wl-sk wl-wl-sk-pills"></div><div class="wl-wl-sk wl-wl-sk-btn"></div></div></div>'; }
  function wlEnsureMap(ids){
    var need = !_wishMap || ids.some(function(id){ return !_wishMap[id]; });
    if(!need) return Promise.resolve(_wishMap);
    if(_wishMapInflight) return _wishMapInflight;
    var q=encodeURIComponent('id:'+ids.join(' OR id:'));
    var url=(SEARCH_URL||'/search')+'?view=wishlist&type=product&options[unavailable_products]=last&q='+q+'&section_id=main-search';
    _wishMapInflight=fetch(url).then(function(r){ return r.ok?r.text():''; }).then(function(html){
      _wishMap=_wishMap||{};
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      [].forEach.call(tmp.querySelectorAll('.hdt-card-product'), function(card){ var w=card.querySelector('hdt-wishlist[data-id]'); var id=w?w.getAttribute('data-id'):null; var a=card.querySelector('a[href*="/products/"]'); var h=a?(a.getAttribute('href').split('/products/')[1]||'').split('?')[0].split('#')[0]:null; if(id&&h&&!_wishMap[id]) _wishMap[id]=h; });
      _wishMapInflight=null; return _wishMap;
    }).catch(function(){ _wishMapInflight=null; return _wishMap||{}; });
    return _wishMapInflight;
  }
  function wlGetProduct(handle){
    if(_wishCache[handle]) return Promise.resolve(_wishCache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){ return r.ok?r.json():null; }).then(function(p){ if(p){ if(!p.url) p.url='/products/'+handle; _wishCache[handle]=p; } return p; }).catch(function(){ return null; });
  }
  function wlFillCard(id, p){ var d=wishDrawerEl(); if(!d) return; var el=d.querySelector('.wl-wl-card[data-pid="'+id+'"]'); if(!el) return; var tmp=document.createElement('div'); tmp.innerHTML=wlCardHTML(p, id, _wishCartVids); var nu=tmp.firstChild; if(nu) el.replaceWith(nu); }
  function wlDropCard(id){ var d=wishDrawerEl(); if(!d) return; var el=d.querySelector('.wl-wl-card[data-pid="'+id+'"]'); if(el) el.remove(); var grid=d.querySelector('.wl-wl-grid'); if(grid && !grid.querySelector('.wl-wl-card')){ var body=d.querySelector('[data-wl-wish-body]'); if(body) body.innerHTML=wlEmptyHTML(); } }
  function renderWish(){
    var d=wishDrawerEl(); if(!d) return;
    var body=d.querySelector('[data-wl-wish-body]'), cEl=d.querySelector('[data-wl-wish-count]');
    var ids=wishIds();
    if(cEl) cEl.textContent = ids.length ? ids.length+(ids.length>1?' items':' item') : '';
    if(!ids.length){ body.innerHTML=wlEmptyHTML(); return; }
    function paintFinal(){
      var html=ids.map(function(id){ var h=_wishMap&&_wishMap[id]; var p=h&&_wishCache[h]; return p?wlCardHTML(p,id,_wishCartVids):''; }).filter(Boolean).join('');
      body.innerHTML = html ? '<div class="wl-wl-grid">'+html+'</div>' : wlEmptyHTML();
    }
    /* Instant path: product data was preloaded → render straight from cache (no skeleton
       flash, no network wait), then quietly refresh in-bag state from the live cart. */
    var cached = _wishMap && ids.every(function(id){ return _wishMap[id] && _wishCache[_wishMap[id]]; });
    if(cached){ paintFinal(); wlLoadCart().then(function(){ if(d.classList.contains('is-open')) paintFinal(); }); return; }
    body.innerHTML='<div class="wl-wl-grid">'+ids.map(function(id){ return wlSkeletonHTML(id); }).join('')+'</div>';
    Promise.all([wlEnsureMap(ids), wlLoadCart()]).then(function(res){
      var map=res[0]||{};
      if(!d.classList.contains('is-open')) return;
      if(!ids.some(function(id){ return map[id]; })){ body.innerHTML=wlEmptyHTML(); return; }
      ids.forEach(function(id){
        var h=map[id]; if(!h){ wlDropCard(id); return; }
        wlGetProduct(h).then(function(p){ if(!d.classList.contains('is-open')) return; if(p) wlFillCard(id, p); else wlDropCard(id); });
      });
    });
  }
  /* Warm the wishlist cache in the background so the drawer opens instantly. */
  function preloadWish(){
    var ids=wishIds(); if(!ids.length) return;
    wlLoadCart();
    wlEnsureMap(ids).then(function(map){ ids.forEach(function(id){ var h=map&&map[id]; if(h) wlGetProduct(h); }); }).catch(function(){});
  }
  function wishAdd(vid, btn){
    if(!vid) return;
    var card = btn && btn.closest('.wl-wl-card');
    if(btn){ btn.disabled=true; btn.classList.add('is-loading'); btn.textContent='Adding\u2026'; }
    addVariant(vid).then(function(){
      _wishCartVids[String(vid)]=(_wishCartVids[String(vid)]||0)+1;
      if(card){ var pill=card.querySelector('.wl-wl-size[data-vid="'+vid+'"]'); if(pill){ pill.classList.add('is-inbag'); pill.classList.remove('is-sel'); pill.disabled=true; } wlUpdateInbag(card); }
      if(!btn) return;
      btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.textContent='Added to Bag \u2713';
      setTimeout(function(){ btn.classList.remove('is-done'); if(card && card.querySelector('.wl-wl-size')){ btn.disabled=true; btn.removeAttribute('data-vid'); btn.textContent='Select Size'; } else { btn.disabled=true; btn.classList.add('is-inbag'); btn.textContent='In Bag \u2713'; } }, 1600);
    });
  }
  function wishRemove(pid){
    var ids=wishIds().filter(function(x){ return x!==String(pid); });
    try{ localStorage.setItem('theme4:wishlist:id', ids.join(',')); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('theme4:wishlist:update',{bubbles:true,detail:ids})); }catch(e){}
  }

  (function(){ var _ir=root(); if(_ir){ setTimeout(function(){ _ir.classList.remove('wl-anim-in'); }, 1700); } })();
  initPin();
  initEta();
  initOffers();
  initStickyReveal();
  initOfferPeeks();
  initWishBadge();
  updateSelUI();
  refreshSizeAvailability();
  (function(){ var all=document.querySelectorAll('[data-wl-wishdrawer]'); for(var i=1;i<all.length;i++){ all[i].remove(); } var d=all[0]; if(d && d.parentNode!==document.body) document.body.appendChild(d); })();
  (function(){ var all=document.querySelectorAll('[data-wl-recsdrawer]'); for(var i=1;i<all.length;i++){ all[i].remove(); } var d=all[0]; if(d && d.parentNode!==document.body) document.body.appendChild(d); })();
  (function(){ var warm=function(){ try{ preloadWish(); }catch(e){} }; if(window.requestIdleCallback){ requestIdleCallback(warm, { timeout:2000 }); } else { setTimeout(warm, 800); } })();
  /* The native discount component (hdt-cart-discount) mutates the cart outside our AJAX
     paths; it fires theme cart/discount events. Refresh our summary the instant it does so
     an applied/removed coupon reflects in the total without a page reload. */
  ['cart:update','discount:update','cart:reload'].forEach(function(ev){ document.addEventListener(ev, function(){ reconcileFromServer(); }); });
  document.addEventListener('click', function(e){
    if(!e.target||!e.target.closest) return;
    var wo=e.target.closest('[data-wl-wish-open]'); if(wo){ e.preventDefault(); openWish(); return; }
    var wc=e.target.closest('[data-wl-wish-close]'); if(wc){ e.preventDefault(); closeWish(); return; }
    var ro=e.target.closest('[data-wl-recs-open]'); if(ro){ e.preventDefault(); openRecs(); return; }
    var rc=e.target.closest('[data-wl-recs-close]'); if(rc){ e.preventDefault(); closeRecs(); return; }
    var sz=e.target.closest('.wl-wl-size'); if(sz){ if(sz.disabled) return; var card=sz.closest('.wl-wl-card'); if(card){ [].forEach.call(card.querySelectorAll('.wl-wl-size'), function(b){ b.classList.remove('is-sel'); }); sz.classList.add('is-sel'); var atc=card.querySelector('[data-wl-wl-add]'); if(atc){ atc.disabled=false; atc.setAttribute('data-vid', sz.getAttribute('data-vid')); if(!atc.classList.contains('is-done')&&!atc.classList.contains('is-loading')) atc.textContent='Add to Bag'; } } return; }
    var add=e.target.closest('[data-wl-wl-add]'); if(add){ if(add.disabled) return; e.preventDefault(); wishAdd(add.getAttribute('data-vid'), add); return; }
    var del=e.target.closest('[data-wl-wl-remove]'); if(del){ e.preventDefault(); wishRemove(del.getAttribute('data-pid')); return; }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ var d=wishDrawerEl(); if(d && d.classList.contains('is-open')) closeWish(); var rd=recsDrawerEl(); if(rd && rd.classList.contains('is-open')) closeRecs(); } });
  document.addEventListener('theme4:wishlist:update', initWishBadge);
  document.addEventListener('theme4:wishlist:update', function(){ var d=wishDrawerEl(); if(d && d.classList.contains('is-open')) renderWish(); });

  /* Exposed so the optional exact-money optimizer (assets/wl-cart-drawer-opt.js) can
     reuse this page's own server-render + re-init pipeline instead of duplicating it.
     Harmless when the optimizer flag is off — nothing calls it. */
  window.wlCartAPI = {
    root: root,
    sectionId: sid,
    swapFrom: swapFrom,
    postCart: postCart,
    reconcile: reconcileFromServer,
    refreshSizeAvailability: refreshSizeAvailability,
    syncCount: syncCount,
    addWishlist: addWishlist,
    animateOut: animateOut,
    showEmptyImmediately: showEmptyImmediately,
    notice: cartNotice
  };
})();